import { type UseQueryResult, useQuery } from 'react-query';
import {
  CustomerUserService,
  // eslint-disable-next-line camelcase
  type PagedResultDto_CustomerUserDto,
} from '@wealthlane/api-services/wealthlane-customer-service';
import { resolveTenantScope, type TenantScope } from '../../constants/tenantScope';
import { type TableParamsType } from '../../types/common';

const useGetAllCustomerUserList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType,
  scopeOverride?: TenantScope
  // status?: number[]
  // isEnabled?: boolean[]
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_CustomerUserDto | undefined,
  unknown
> => {
  const { filter, sorting, skipCount, maxResultCount, status, isEnabled, scope, _force } =
    tableInfo;
  const resolvedScope = resolveTenantScope(scopeOverride ?? scope);

  const allCustomerUserList = useQuery(
    [
      'getAllCustomerUserList',
      status,
      isEnabled,
      resolvedScope,
      filter,
      sorting,
      skipCount,
      maxResultCount,
      _force,
    ],
    async () => {
      return await handleRequest(
        CustomerUserService.getApiCustomerApiAppCustomerUserCustomerUserList(
          status,
          isEnabled ? isEnabled : [true],
          resolvedScope,
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
    // {
    //   keepPreviousData: true,
    // }
  );
  return allCustomerUserList;
};

export default useGetAllCustomerUserList;
